import { gql } from '@provision/graphql-client';
import { USER_SETTING_VALUE_FRAGMENT } from 'src/graphql/entities/user-setting-value/user-setting-value.fragments';

export const GET_MY_USER_GROUP_SETTING_VALUES_QUERY = gql`
  query GetMyUserGroupSettingValues {
    getMyUserGroupSettingValues {
      id
      userGroupId
      userSettingId
      value
    }
  }
`;

// reads the current user's own setting values across every partner they can access
// (run with `omitIsolationModeHeader` so no `ov-partner-ids` header is sent). This is
// how a personalized side-panel layout follows the user between tenants instead of
// resetting to the default when they switch partners.
export const GET_MY_CROSS_PARTNER_USER_SETTINGS_QUERY = gql`
  query GetMyCrossPartnerUserSettings($params: QueryParamsWithSearch)
  @entity(name: "PlatformUser") {
    getPlatformUser(queryParams: $params) {
      records {
        id
        userSettingValues {
          ...UserSettingValueFields
        }
      }
    }
  }
  ${USER_SETTING_VALUE_FRAGMENT}
`;
